import React from 'react'
import { observer } from 'mobx-react'
import { Modal } from 'react-bootstrap'
import * as defaultConst from '../../../constants/default_constants'

const OmdbModalForm = ({ store }) => {
  const OMDBdata = store.cv.omdb && store.cv.omdb.data &&
    Object.keys(store.cv.omdb.data).length > 3 ? store.cv.omdb.data : false

  function _renderTable () {
    const rows = []
    for (const k in OMDBdata) {
      const posterLink = k.toString() === 'Poster'
      rows.push(
        <tr key={k}>
          <td style={{ verticalAlign: 'top' }}>{k.toString()}:</td>
          <td><div className={posterLink && 'enum-item-wrap'}>
            {!posterLink
              ? JSON.stringify(OMDBdata[k])
              : <a href={JSON.parse(JSON.stringify(OMDBdata[k]))} target='_blank' rel='noreferrer'>
                {JSON.stringify(OMDBdata[k])}
              </a>
            }
          </div></td>
        </tr>
      )
    }
    return rows
  }

  const disabled = !(store.cv.omdb && store.cv.omdb.data &&
    Object.prototype.hasOwnProperty.call(store.cv.omdb.data, 'Title'))

  return OMDBdata !== false ? (
    <Modal show backdrop='static' onHide={() => store.cv.omdb.cancelOMDBload()}>
      <Modal.Header closeButton>
        <Modal.Title>
          {store.__('Data downloaded from OMDB API')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <table style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '20%' }}>{store.__('Attribute name')}</th>
                <th>{store.__('Attribute value')}</th>
              </tr>
            </thead>
            <tbody>
              {_renderTable()}
            </tbody>
          </table>
        </div><br />

        {disabled &&
        <div className='alert alert-danger'><strong>{store.__('Error!')}</strong> &nbsp;
          {store.__('The downloaded data is not complete, the record cannot be saved.')}
        </div>}
        {!(store.cv.omdb && store.cv.omdb.data &&
        Object.prototype.hasOwnProperty.call(store.cv.omdb.data, 'PlotFull')) &&
        <div className='alert alert-warning'><strong>{store.__('WARNING').concat(': ')}</strong> &nbsp;
          {store.__('Long synopsis is missing.')}
        </div>}

      </Modal.Body>
      <Modal.Footer>
        <div className='btn-group' role='group'>
          <button type='button' className='btn btn-primary' disabled={disabled}
            onClick={() => store.cv.omdb.saveOMDBdata(true)}>
            {store.__(defaultConst.TITLE_INSERT_OVERWRITE_Y)}
          </button>
          <button type='button' className='btn btn-primary' disabled={disabled}
            onClick={() => store.cv.omdb.saveOMDBdata(false)}>
            {store.__(defaultConst.TITLE_INSERT_OVERWRITE_N)}
          </button>
          <button type='button' className='btn btn-default'
            onClick={() => store.cv.omdb.cancelOMDBload()}>
            {store.__(defaultConst.TITLE_CANCEL)}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  ) : null
}

export default observer(OmdbModalForm)
